var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaWhiteSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08366 27V4.19167C6.08351 3.70693 6.24437 3.23587 6.54099 2.85247C6.8376 2.46907 7.25316 2.19505 7.7224 2.07345C8.19164 1.95185 8.68798 1.98955 9.13347 2.18064C9.57895 2.37172 9.94835 2.70536 10.1837 3.12917L22.817 25.8708C23.0523 26.2946 23.4217 26.6283 23.8672 26.8194C24.3126 27.0104 24.809 27.0481 25.2782 26.9265C25.7475 26.8049 26.163 26.5309 26.4596 26.1475C26.7563 25.7641 26.9171 25.2931 26.917 24.8083V2M1.91699 10.3333H31.0836M1.91699 18.6667H31.0836",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaWhiteSymbol);
export default __webpack_public_path__ + "static/media/nairaWhiteSymbol.619a044dba694a5fa458b1e255204d3b.svg";
export { ForwardRef as ReactComponent };